import GridItem from '../GridItem';
import ImageItem from '../ImageItem';

import type { ImagesGalleryItem } from '../../../types';

const ELEMENTS_PER_SCROLL = 6;
const IMAGE_GROUP_HIGH_HEIGHT = '730px';
const IMAGE_GROUP_GAP = '10px';
const IMAGE_GROUP_LOW_HEIGHT = '430px';

type Props = {
  elements: ImagesGalleryItem[];
  toggleView: (index: number) => void;
};

const ImageList = ({ elements, toggleView }: Props) => {
  const groupImage = [];

  for (let i = 0; i <= elements.length; i += ELEMENTS_PER_SCROLL) {
    groupImage.push({
      id: i,
      content: [...elements.slice(i, i + ELEMENTS_PER_SCROLL)],
    });
  }

  return (
    <div id="mediaWallList">
      {groupImage.map((group, groupIndex) => {
        if (group.content && group.content.length > 0) {
          return (
            <div
              key={group.id}
              style={{
                height:
                  group.content.length > 3
                    ? IMAGE_GROUP_HIGH_HEIGHT
                    : IMAGE_GROUP_LOW_HEIGHT,
                marginBottom: IMAGE_GROUP_GAP,
              }}
            >
              <GridItem imageNumber={group.content.length}>
                {group.content.map((image, imageIndex) => (
                  <ImageItem
                    key={`${image.category}_${image.thumbnail}`}
                    item={image}
                    index={groupIndex * ELEMENTS_PER_SCROLL + imageIndex}
                    toggleView={toggleView}
                  />
                ))}
              </GridItem>
            </div>
          );
        }

        return null;
      })}
    </div>
  );
};

export default ImageList;
